/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pg_Vekn_Claim_ModalInputs */



/**
* | output |
* | --- |
* | "A modal will open asking for your VEKN ID number:" |
*
* @param {Pg_Vekn_Claim_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const pg_vekn_claim_modal = /** @type {((inputs?: Pg_Vekn_Claim_ModalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pg_Vekn_Claim_ModalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une fenêtre s'ouvrira pour demander votre numéro de VEKN ID :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se abrirá un modal solicitando su número de ID VEKN:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um modal será aberto solicitando seu número de ID VEKN:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si aprirà un modale che chiede il numero del tuo VEKN ID:")
	return /** @type {LocalizedString} */ ("A modal will open asking for your VEKN ID number:")
});